module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Sneakers-d8404d442f11554202e813f6a5602ec9.svg";